module.exports = __webpack_public_path__ + "static/media/preset1.21218f74.svg";